module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-alert', {
    attrs: {
      "dismissible": "",
      "type": "success"
    },
    model: {
      value: (_vm.alertStatus),
      callback: function($$v) {
        _vm.alertStatus = $$v
      },
      expression: "alertStatus"
    }
  }, [_vm._v("Success. Your catalog should arrive within the next week.")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "edit",
      "label": "Company"
    },
    model: {
      value: (_vm.data.company),
      callback: function($$v) {
        _vm.$set(_vm.data, "company", $$v)
      },
      expression: "data.company"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:20'),
      expression: "'required|max:20'"
    }],
    attrs: {
      "append-icon": "edit",
      "error-messages": _vm.errors.collect('name'),
      "data-vv-name": "name",
      "required": "",
      "label": "Full Name"
    },
    model: {
      value: (_vm.data.name),
      callback: function($$v) {
        _vm.$set(_vm.data, "name", $$v)
      },
      expression: "data.name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.countries,
      "label": "Country"
    },
    model: {
      value: (_vm.data.country),
      callback: function($$v) {
        _vm.$set(_vm.data, "country", $$v)
      },
      expression: "data.country"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "error-messages": _vm.errors.collect('region'),
      "data-vv-name": "region",
      "require": "",
      "items": _vm.regions,
      "label": "State"
    },
    model: {
      value: (_vm.data.region),
      callback: function($$v) {
        _vm.$set(_vm.data, "region", $$v)
      },
      expression: "data.region"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:50'),
      expression: "'required|max:50'"
    }],
    attrs: {
      "append-icon": "book",
      "error-messages": _vm.errors.collect('address1'),
      "data-vv-name": "address1",
      "required": "",
      "label": "Address 1"
    },
    model: {
      value: (_vm.data.address1),
      callback: function($$v) {
        _vm.$set(_vm.data, "address1", $$v)
      },
      expression: "data.address1"
    }
  })], 1), _vm._v(" "), (_vm.data.address1 != '') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:50'),
      expression: "'max:50'"
    }],
    attrs: {
      "append-icon": "book",
      "error-messages": _vm.errors.collect('address2'),
      "data-vv-name": "address2",
      "label": "Address 2"
    },
    model: {
      value: (_vm.data.address2),
      callback: function($$v) {
        _vm.$set(_vm.data, "address2", $$v)
      },
      expression: "data.address2"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:20'),
      expression: "'required|max:20'"
    }],
    attrs: {
      "append-icon": "edit",
      "error-messages": _vm.errors.collect('city'),
      "data-vv-name": "city",
      "required": "",
      "label": "City"
    },
    model: {
      value: (_vm.data.city),
      callback: function($$v) {
        _vm.$set(_vm.data, "city", $$v)
      },
      expression: "data.city"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        regex: /^([0-9]{5}$)|(([ABC][0-9]){3})$/
      }),
      expression: "{regex: /^([0-9]{5}$)|(([ABC][0-9]){3})$/}"
    }],
    attrs: {
      "append-icon": "edit",
      "error-messages": _vm.errors.collect('zip'),
      "data-vv-name": "zip",
      "required": "",
      "label": "Zip/Postal Code"
    },
    model: {
      value: (_vm.data.zip),
      callback: function($$v) {
        _vm.$set(_vm.data, "zip", $$v)
      },
      expression: "data.zip"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "d-flex": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }],
    attrs: {
      "append-icon": "email",
      "error-messages": _vm.errors.collect('email'),
      "label": "Email",
      "data-vv-name": "email",
      "required": ""
    },
    model: {
      value: (_vm.data.email),
      callback: function($$v) {
        _vm.$set(_vm.data, "email", $$v)
      },
      expression: "data.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "d-flex": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Subscribe to Email List"
    },
    model: {
      value: (_vm.data.subscribe),
      callback: function($$v) {
        _vm.$set(_vm.data, "subscribe", $$v)
      },
      expression: "data.subscribe"
    }
  })], 1), _vm._v(" "), (_vm.data.email != '') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "d-flex": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:20'),
      expression: "'max:20'"
    }],
    attrs: {
      "append-icon": "edit",
      "error-messages": _vm.errors.collect('phone'),
      "data-vv-name": "phone",
      "label": "Phone"
    },
    model: {
      value: (_vm.data.phone),
      callback: function($$v) {
        _vm.$set(_vm.data, "phone", $$v)
      },
      expression: "data.phone"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.data.email == '') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "d-flex": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:20'),
      expression: "'required|max:20'"
    }],
    attrs: {
      "append-icon": "edit",
      "error-messages": _vm.errors.collect('phone'),
      "data-vv-name": "phone",
      "required": "",
      "label": "Phone"
    },
    model: {
      value: (_vm.data.phone),
      callback: function($$v) {
        _vm.$set(_vm.data, "phone", $$v)
      },
      expression: "data.phone"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "d-flex": ""
    }
  }, [_c('v-autocomplete', {
    ref: "interests",
    attrs: {
      "items": _vm.interestsList,
      "label": "Interests",
      "append-icon-cb": _vm.closeInterests,
      "multiple": "",
      "chips": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          key: JSON.stringify(data.item),
          staticClass: "chip--select-multi",
          attrs: {
            "close": "",
            "selected": data.selected
          },
          on: {
            "input": function($event) {
              data.parent.selectItem(data.item)
            }
          }
        }, [_vm._v("\n             " + _vm._s(data.item) + "\n            ")])]
      }
    }]),
    model: {
      value: (_vm.data.interests),
      callback: function($$v) {
        _vm.$set(_vm.data, "interests", $$v)
      },
      expression: "data.interests"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-autocomplete', {
    ref: "hear",
    attrs: {
      "items": _vm.hearList,
      "label": "How did you hear about Kencove?",
      "append-icon-cb": _vm.closeHear,
      "multiple": "",
      "chips": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          key: JSON.stringify(data.item),
          staticClass: "chip--select-multi",
          attrs: {
            "close": "",
            "selected": data.selected
          },
          on: {
            "input": function($event) {
              data.parent.selectItem(data.item)
            }
          }
        }, [_vm._v("\n             " + _vm._s(data.item) + "\n            ")])]
      }
    }]),
    model: {
      value: (_vm.data.hear),
      callback: function($$v) {
        _vm.$set(_vm.data, "hear", $$v)
      },
      expression: "data.hear"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "edit",
      "label": "Which one?"
    },
    model: {
      value: (_vm.data.which),
      callback: function($$v) {
        _vm.$set(_vm.data, "which", $$v)
      },
      expression: "data.which"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "d-flex": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "name": "input-3-1",
      "label": "Additional product information?",
      "append-icon": "note"
    },
    model: {
      value: (_vm.data.additional),
      callback: function($$v) {
        _vm.$set(_vm.data, "additional", $$v)
      },
      expression: "data.additional"
    }
  })], 1)], 1), _vm._v(" "), _c('vue-recaptcha', {
    attrs: {
      "sitekey": "6LdddXsUAAAAAGHumerT5AvTLmu3ruDnZFCuY8M8"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitForm2($event)
      }
    }
  }, [_vm._v("Order Catalog")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d72dd65!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/catalog_request_form.vue
// module id = 96
// module chunks = 2